<div class="create-tramites-container">
  <div class="container-fluid py-4">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-md-8">
        <h2 class="page-title">
          <i class="fa fa-plus-circle"></i> Crear Nuevo Trámite
        </h2>
        <p class="subtitle">Complete el formulario para registrar un nuevo trámite en el catálogo</p>
      </div>
      <div class="col-md-4 text-right align-self-center">
        <button type="button" class="btn btn-secondary" (click)="cancel()">
          <i class="fa fa-times"></i> Cancelar
        </button>
        <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="isLoading">
          <i class="fa" [ngClass]="isLoading ? 'fa-spinner fa-spin' : 'fa-save'"></i> 
          {{ isLoading ? 'Guardando...' : 'Guardar Trámite' }}
        </button>
      </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="card shadow-sm mb-4">
        <div class="card-body">
          <ngb-tabset class="tab-coupon">
            <!-- Tab: General -->
            <ngb-tab title="General">
              <ng-template ngbTabContent>
                <div class="pt-3">
                  <!-- Sección: Información Básica -->
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-primary text-white">
          <h5 class="mb-0"><i class="fa fa-info-circle"></i> Información Básica</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Dependencia</label>
              <ng-select 
                formControlName="department" 
                [class.is-invalid]="hasError('department')"
                [items]="dependencias || []"
                bindLabel="Name" 
                bindValue="id"
                [searchable]="true"
                [clearable]="true"
                placeholder="Buscar y seleccionar una dependencia..."
                notFoundText="No se encontraron dependencias">
              </ng-select>
              <div class="invalid-feedback" *ngIf="hasError('department')">
                {{ getErrorMessage('department') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Área <span class="text-danger">*</span></label>
              <ng-select 
                formControlName="area" 
                [class.is-invalid]="hasError('area')"
                [items]="areas || []"
                bindLabel="Name" 
                bindValue="id"
                [searchable]="true"
                [clearable]="true"
                placeholder="Buscar y seleccionar un área..."
                notFoundText="No se encontraron áreas">
              </ng-select>
              <div class="invalid-feedback" *ngIf="hasError('area')">
                {{ getErrorMessage('area') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Nombre del Trámite <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="name" 
                [class.is-invalid]="hasError('name')" placeholder="Ej: Certificado de No Adeudo">
              <div class="invalid-feedback" *ngIf="hasError('name')">
                {{ getErrorMessage('name') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Código del Trámite <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="code" 
                [class.is-invalid]="hasError('code')" placeholder="Ej: CNA001">
              <div class="invalid-feedback" *ngIf="hasError('code')">
                {{ getErrorMessage('code') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Tipo de documento a obtener <span class="text-danger">*</span></label>
              <ng-select 
                formControlName="type" 
                [class.is-invalid]="hasError('type')"
                [items]="tiposDocumento || []"
                bindLabel="label" 
                bindValue="value"
                [searchable]="true"
                [clearable]="true"
                placeholder="Buscar y seleccionar un tipo de documento..."
                notFoundText="No se encontraron tipos de documento">
              </ng-select>
              <div class="invalid-feedback" *ngIf="hasError('type')">
                {{ getErrorMessage('type') }}
              </div>
            </div>


            <div class="col-md-6 mb-3">
              <label class="form-label">Solicitante <span class="text-danger">*</span></label>
              <div class="select-checkbox-container" [class.is-invalid]="hasError('applicant')">
                <div class="select-checkbox-header" (click)="toggleSolicitanteDropdown()">
                  <span class="select-checkbox-selected">
                    <span *ngIf="applicantSelected.length === 0" class="text-muted">Seleccione el tipo de solicitante</span>
                    <span *ngIf="applicantSelected.length > 0">{{ applicantSelected.join(', ') }}</span>
                  </span>
                  <i class="fa fa-chevron-down" [class.fa-chevron-up]="isSolicitanteDropdownOpen"></i>
                </div>
                <div class="select-checkbox-dropdown" *ngIf="isSolicitanteDropdownOpen" (click)="$event.stopPropagation()">
                  <div class="select-checkbox-item" *ngFor="let tipo of tiposSolicitante">
                    <label class="checkbox-label">
                      <input 
                        type="checkbox" 
                        [value]="tipo.value"
                        [checked]="isApplicantSelected(tipo.value)"
                        (change)="toggleApplicant(tipo.value)"
                        (click)="$event.stopPropagation()">
                      <span>{{ tipo.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
              <input type="hidden" [formControl]="form.get('applicant')">
              <div class="invalid-feedback" *ngIf="hasError('applicant')">
                {{ getErrorMessage('applicant') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Modalidades de Atención</label>
              <div class="select-checkbox-container" [class.is-invalid]="hasError('modalidades')">
                <div class="select-checkbox-header" (click)="toggleModalidadesDropdown()">
                  <span class="select-checkbox-selected">
                    <span *ngIf="modalidadesSelected.length === 0" class="text-muted">Seleccione las modalidades de atención</span>
                    <span *ngIf="modalidadesSelected.length > 0">{{ modalidadesSelected.join(', ') }}</span>
                  </span>
                  <i class="fa fa-chevron-down" [class.fa-chevron-up]="isModalidadesDropdownOpen"></i>
                </div>
                <div class="select-checkbox-dropdown" *ngIf="isModalidadesDropdownOpen" (click)="$event.stopPropagation()">
                  <div class="select-checkbox-item" *ngFor="let modalidad of tiposModalidades">
                    <label class="checkbox-label">
                      <input 
                        type="checkbox" 
                        [value]="modalidad.value"
                        [checked]="isModalidadSelected(modalidad.value)"
                        (change)="toggleModalidad(modalidad.value)"
                        (click)="$event.stopPropagation()">
                      <span>{{ modalidad.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
              <input type="hidden" [formControl]="form.get('modalidades')">
              <input type="hidden" formControlName="isOnline">
              <input type="hidden" formControlName="isPresencial">
              <input type="hidden" formControlName="isConCita">
              <div class="invalid-feedback" *ngIf="hasError('modalidades')">
                {{ getErrorMessage('modalidades') }}
              </div>
            </div>

            <div class="col-md-12 mb-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="tieneCosto" formControlName="tieneCosto">
                <label class="form-check-label" for="tieneCosto">¿Tiene costo?</label>
              </div>
            </div>

            <div class="col-md-6 mb-3" *ngIf="form.get('tieneCosto')?.value">
              <label class="form-label">Costo</label>
              <input type="number" class="form-control" formControlName="costo" 
                min="0" step="0.01" placeholder="Ej: 150.00">
            </div>

            <div class="col-md-6 mb-3" *ngIf="form.get('tieneCosto')?.value">
              <label class="form-label">Formas de pago</label>
              <div class="select-checkbox-container">
                <div class="select-checkbox-header" (click)="toggleFormasPagoDropdown()">
                  <span class="select-checkbox-selected">
                    <span *ngIf="formasPagoSelected.length === 0" class="text-muted">Seleccione las formas de pago</span>
                    <span *ngIf="formasPagoSelected.length > 0">{{ formasPagoSelected.join(', ') }}</span>
                  </span>
                  <i class="fa fa-chevron-down" [class.fa-chevron-up]="isFormasPagoDropdownOpen"></i>
                </div>
                <div class="select-checkbox-dropdown" *ngIf="isFormasPagoDropdownOpen" (click)="$event.stopPropagation()">
                  <div class="select-checkbox-item" *ngFor="let formaPago of formasPagoOptions">
                    <label class="checkbox-label">
                      <input 
                        type="checkbox" 
                        [value]="formaPago.value"
                        [checked]="isFormaPagoSelected(formaPago.value)"
                        (change)="toggleFormaPago(formaPago.value)"
                        (click)="$event.stopPropagation()">
                      <span>{{ formaPago.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
              <input type="hidden" [formControl]="form.get('formasPago')">
            </div>
          </div>
        </div>
      </div>

      <!-- Sección: Tiempos y Vigencia -->
      <div class="card shadow-sm mb-4 tiempos-vigencia-section">
        <div class="card-header bg-info text-white">
          <h5 class="mb-0"><i class="fa fa-clock"></i> Tiempos y Vigencia</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 mb-3">
              <label class="form-label">Tiempo de Respuesta <span class="text-danger">*</span></label>
              <input type="number" class="form-control" formControlName="answerTime" 
                [class.is-invalid]="hasError('answerTime')" min="0" placeholder="0">
              <div class="invalid-feedback" *ngIf="hasError('answerTime')">
                {{ getErrorMessage('answerTime') }}
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <label class="form-label">U.M. Tiempo respuesta <span class="text-danger">*</span></label>
              <select class="form-select" formControlName="answerTimeType" [class.is-invalid]="hasError('answerTimeType')">
                <option value="Días hábiles">Días hábiles</option>
                <option value="Días naturales">Días naturales</option>
              </select>
              <div class="invalid-feedback" *ngIf="hasError('answerTimeType')">
                {{ getErrorMessage('answerTimeType') }}
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <label class="form-label">Vigencia del Documento</label>
              <input type="number" class="form-control" formControlName="validity" min="0" placeholder="0">
            </div>

            <div class="col-md-4 mb-3">
              <label class="form-label">U.M. Vigencia del documento</label>
              <select class="form-select" formControlName="validityType">
                <option value="Días naturales">Días naturales</option>
                <option value="Días hábiles">Días hábiles</option>
                <option value="Años">Años</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección: Descripción del Trámite -->
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-warning text-dark">
          <h5 class="mb-0"><i class="fa fa-file-text"></i> Descripción del Trámite</h5>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <label class="form-label">Descripción <span class="text-danger">*</span></label>
            <textarea class="form-control" formControlName="description" rows="4" 
              [class.is-invalid]="hasError('description')" 
              placeholder="Describa detalladamente el trámite..."></textarea>
            <div class="invalid-feedback" *ngIf="hasError('description')">
              {{ getErrorMessage('description') }}
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Fundamento Jurídico <span class="text-danger">*</span></label>
            <textarea class="form-control" formControlName="legalBase" rows="4" 
              [class.is-invalid]="hasError('legalBase')" 
              placeholder="Mencione las leyes, reglamentos o normativas que rigen este trámite..."></textarea>
            <div class="invalid-feedback" *ngIf="hasError('legalBase')">
              {{ getErrorMessage('legalBase') }}
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Criterios de Resolución</label>
            <textarea class="form-control" formControlName="resolutionCriteria" 
              rows="4" placeholder="Ej: Cumplimiento de requisitos"></textarea>
          </div>

          <div class="row" *ngIf="false">
            <div class="col-md-6 mb-3">
              <label class="form-label">Receptor</label>
              <input type="text" class="form-control" formControlName="recipient" 
                placeholder="¿Quién recibe este trámite?">
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Formatos Autorizados</label>
              <input type="text" class="form-control" formControlName="authorizedFormats" 
                placeholder="Ej: PDF, JPG, PNG">
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Respuesta ante Vulneración de Derechos</label>
              <input type="text" class="form-control" formControlName="rightBreachAnswer" 
                placeholder="Datos de quién responde ante la vulneración">
            </div>
          </div>
        </div>
      </div>

      <!-- Sección: Información de Oficina -->
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-secondary text-white">
          <h5 class="mb-0"><i class="fa fa-building"></i> Información de Oficina</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Oficina</label>
              <input type="text" class="form-control" formControlName="office" 
                placeholder="Ej: Tesorería Municipal">
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Ubicación</label>
              <input type="text" class="form-control" formControlName="location" 
                placeholder="Ej: Edificio Administrativo">
            </div>

            <div class="col-md-12 mb-3">
              <label class="form-label">Dirección</label>
              <input type="text" class="form-control" formControlName="address" 
                placeholder="Calle y número">
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Teléfono de Oficina</label>
              <input type="text" class="form-control" formControlName="officePhone" 
                placeholder="Ej: (229) 200-2000">
            </div>

            <div class="col-md-3 mb-3">
              <label class="form-label">Extensión</label>
              <input type="text" class="form-control" formControlName="extension" 
                placeholder="Ej: 123">
            </div>

            <div class="col-md-3 mb-3">
              <label class="form-label">Horario</label>
              <input type="text" class="form-control" formControlName="schedule" 
                placeholder="Ej: L-V 9:00-18:00">
            </div>
          </div>
        </div>
      </div>

      <!-- Sección: Información de Consulta -->
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-dark text-white">
          <h5 class="mb-0"><i class="fa fa-question-circle"></i> Información de Consulta</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Atendido por <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="attender" 
                [class.is-invalid]="hasError('attender')" placeholder="Nombre del responsable">
              <div class="invalid-feedback" *ngIf="hasError('attender')">
                {{ getErrorMessage('attender') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Cargo</label>
              <input type="text" class="form-control" formControlName="role" 
                placeholder="Ej: Director de Tesorería">
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Teléfono</label>
              <input type="text" class="form-control" formControlName="inquiryPhone" 
                placeholder="Teléfono de contacto">
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Email</label>
              <input type="email" class="form-control" formControlName="inquiryEmail" 
                [class.is-invalid]="hasError('inquiryEmail')" placeholder="correo@ejemplo.com">
              <div class="invalid-feedback" *ngIf="hasError('inquiryEmail')">
                {{ getErrorMessage('inquiryEmail') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Dirección de Consulta</label>
              <input type="text" class="form-control" formControlName="inquiryAddress" 
                placeholder="Dirección para realizar consultas">
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Horario de Consulta</label>
              <input type="text" class="form-control" formControlName="inquirySchedule" 
                placeholder="Horario de atención para consultas">
            </div>
          </div>
        </div>
      </div>

      <!-- Sección: Configuración -->
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-danger text-white">
          <h5 class="mb-0"><i class="fa fa-cog"></i> Configuración</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 mb-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="isVisible" formControlName="isVisible">
                <label class="form-check-label" for="isVisible">Visible</label>
                <p class="small text-muted">Mostrar en catálogo público</p>
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="isLimited" formControlName="isLimited">
                <label class="form-check-label" for="isLimited">Limitado</label>
                <p class="small text-muted">Limitar solicitudes por ciudadano</p>
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="isRequestable" formControlName="isRequestable">
                <label class="form-check-label" for="isRequestable">Solicitable</label>
                <p class="small text-muted">Permitir solicitudes de este trámite</p>
              </div>
            </div>
          </div>
        </div>
      </div>
                </div>
              </ng-template>
            </ngb-tab>

            <!-- Tab: Requisitos -->
            <ngb-tab title="Requisitos">
              <ng-template ngbTabContent>
                <div class="pt-3">
                  <!-- Formulario para agregar requisitos -->
                  <div class="card shadow-sm mb-4">
                    <div class="card-header bg-primary text-white">
                      <h5 class="mb-0"><i class="fa fa-plus-circle"></i> Agregar Requisito</h5>
                    </div>
                    <div class="card-body">
                      <form [formGroup]="requisitosForm" (ngSubmit)="addRequisito()">
                        <div class="row">
                          <div class="col-md-6 mb-3">
                            <label class="form-label">Nombre del requisito <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" formControlName="nombre" 
                              [class.is-invalid]="requisitosForm.get('nombre')?.invalid && requisitosForm.get('nombre')?.touched"
                              placeholder="Ej: Identificación oficial">
                            <div class="invalid-feedback" *ngIf="requisitosForm.get('nombre')?.invalid && requisitosForm.get('nombre')?.touched">
                              El nombre del requisito es requerido
                            </div>
                          </div>
                          <div class="col-md-6 mb-3">
                            <label class="form-label">Descripción <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" formControlName="descripcion" 
                              [class.is-invalid]="requisitosForm.get('descripcion')?.invalid && requisitosForm.get('descripcion')?.touched"
                              placeholder="Ej: INE, Pasaporte, Cédula profesional">
                            <div class="invalid-feedback" *ngIf="requisitosForm.get('descripcion')?.invalid && requisitosForm.get('descripcion')?.touched">
                              La descripción es requerida
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 text-right">
                            <button type="submit" class="btn btn-primary">
                              <i class="fa fa-plus"></i> Agregar
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <!-- Tabla de requisitos -->
                  <div class="card shadow-sm mb-4">
                    <div class="card-header bg-success text-white">
                      <h5 class="mb-0"><i class="fa fa-list"></i> Requisitos del Trámite</h5>
                    </div>
                    <div class="card-body">
                      <div *ngIf="requisitos.length === 0" class="text-center text-muted py-4">
                        <p>No se han agregado requisitos todavía.</p>
                        <p class="small">Utilice el formulario superior para agregar requisitos al trámite.</p>
                      </div>
                      <div *ngIf="requisitos.length > 0" class="table-responsive">
                        <table class="table table-striped table-hover">
                          <thead>
                            <tr>
                              <th width="5%">#</th>
                              <th width="30%">Nombre del requisito</th>
                              <th width="55%">Descripción</th>
                              <th width="10%" class="text-center">Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let requisito of requisitos; let i = index">
                              <td>{{ i + 1 }}</td>
                              <td>{{ requisito.nombre }}</td>
                              <td>{{ requisito.descripcion }}</td>
                              <td class="text-center">
                                <button type="button" class="btn btn-sm btn-danger" (click)="removeRequisito(i)" title="Eliminar requisito">
                                  <i class="fa fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngb-tab>

            <!-- Tab: Formulario -->
            <ngb-tab title="Formulario">
              <ng-template ngbTabContent>
                <div class="pt-3">
                  <!-- Formulario para agregar campos -->
                  <div class="card shadow-sm mb-4">
                    <div class="card-header bg-primary text-white">
                      <h5 class="mb-0"><i class="fa fa-plus-circle"></i> Agregar Campo del Formulario</h5>
                    </div>
                    <div class="card-body">
                      <form [formGroup]="camposFormularioForm" (ngSubmit)="addCampoFormulario()">
                        <div class="row">
                          <div class="col-md-4 mb-3">
                            <label class="form-label">Nombre del campo <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" formControlName="nombreCampo" 
                              [class.is-invalid]="camposFormularioForm.get('nombreCampo')?.invalid && camposFormularioForm.get('nombreCampo')?.touched"
                              placeholder="Ej: Nombre completo">
                            <div class="invalid-feedback" *ngIf="camposFormularioForm.get('nombreCampo')?.invalid && camposFormularioForm.get('nombreCampo')?.touched">
                              El nombre del campo es requerido
                            </div>
                          </div>
                          <div class="col-md-3 mb-3">
                            <label class="form-label">Tipo de dato <span class="text-danger">*</span></label>
                            <select class="form-select" formControlName="tipoDato"
                              [class.is-invalid]="camposFormularioForm.get('tipoDato')?.invalid && camposFormularioForm.get('tipoDato')?.touched">
                              <option value="">Seleccione un tipo</option>
                              <option *ngFor="let tipo of tiposDato" [value]="tipo.value">{{ tipo.label }}</option>
                            </select>
                            <div class="invalid-feedback" *ngIf="camposFormularioForm.get('tipoDato')?.invalid && camposFormularioForm.get('tipoDato')?.touched">
                              El tipo de dato es requerido
                            </div>
                          </div>
                          <div class="col-md-2 mb-3">
                            <label class="form-label">Longitud de campo</label>
                            <input type="number" class="form-control" formControlName="longitudCampo" 
                              min="1" placeholder="Ej: 50">
                          </div>
                          <div class="col-md-3 mb-3 d-flex align-items-end">
                            <div class="form-check form-switch">
                              <input class="form-check-input" type="checkbox" id="obligatorio" formControlName="obligatorio">
                              <label class="form-check-label" for="obligatorio">Obligatorio</label>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 text-right">
                            <button type="submit" class="btn btn-primary">
                              <i class="fa fa-plus"></i> Agregar
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <!-- Tabla de campos del formulario -->
                  <div class="card shadow-sm mb-4">
                    <div class="card-header bg-success text-white">
                      <h5 class="mb-0"><i class="fa fa-list"></i> Lista de Campos a Capturar</h5>
                    </div>
                    <div class="card-body">
                      <div *ngIf="camposFormulario.length === 0" class="text-center text-muted py-4">
                        <p>No se han agregado campos todavía.</p>
                        <p class="small">Utilice el formulario superior para agregar campos al formulario del trámite.</p>
                      </div>
                      <div *ngIf="camposFormulario.length > 0" class="table-responsive">
                        <table class="table table-striped table-hover">
                          <thead>
                            <tr>
                              <th width="5%">#</th>
                              <th width="25%">Nombre del campo</th>
                              <th width="20%">Tipo de dato</th>
                              <th width="15%">Longitud</th>
                              <th width="15%">Obligatorio</th>
                              <th width="10%" class="text-center">Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let campo of camposFormulario; let i = index">
                              <td>{{ i + 1 }}</td>
                              <td>{{ campo.nombreCampo }}</td>
                              <td>{{ campo.tipoDato }}</td>
                              <td>{{ campo.longitudCampo || '-' }}</td>
                              <td>
                                <span *ngIf="campo.obligatorio" class="badge badge-success">Sí</span>
                                <span *ngIf="!campo.obligatorio" class="badge badge-secondary">No</span>
                              </td>
                              <td class="text-center">
                                <button type="button" class="btn btn-sm btn-danger" (click)="removeCampoFormulario(i)" title="Eliminar campo">
                                  <i class="fa fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngb-tab>
          </ngb-tabset>
        </div>
      </div>

      <!-- Botones de acción -->
      <div class="row mb-4">
        <div class="col-12 text-center">
          <button type="button" class="btn btn-secondary btn-lg mr-2" (click)="cancel()">
            <i class="fa fa-times"></i> Cancelar
          </button>
          <button type="submit" class="btn btn-primary btn-lg" [disabled]="isLoading || form.invalid">
            <i class="fa" [ngClass]="isLoading ? 'fa-spinner fa-spin' : 'fa-save'"></i> 
            {{ isLoading ? 'Guardando...' : 'Guardar Trámite' }}
          </button>
        </div>
      </div>

    </form>
  </div>
</div>
